const PERSONIA = "Personia" as const;
const NOMINAS = "Nóminas" as const;

export const SYSTEM_NAME_ID = {
  PERSONIA: 10,
  NOMINAS: 30,
} as const;

export const SYSTEM_NAME = {
  PERSONIA,
  NOMINAS,
  byId: {
    [SYSTEM_NAME_ID.PERSONIA]: PERSONIA,
    [SYSTEM_NAME_ID.NOMINAS]: NOMINAS,
  },
} as const;
